import { Fragment, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSessionStorage } from "react-use";
import Swal from "sweetalert2";
import FooterPostup from "../../modules/public/footer/footer";
import Loading from "../../modules/public/loading/loading";
import Menu from "../../modules/public/menu/menu";
import CompanySection from "./components/CompanySection";
import HeaderSection from "./components/HeaderSection";
import SenderAddress from "./components/SenderAddress";
import ShipmentSectionVip from "./components/Shipments/ShipmentSectionVip";
import useVipAccess from "./hooks/useVipAccess";

const Vip = () => {
  const { hasVipAccess, loading, hasFinancialOrder } = useVipAccess();

  const navigate = useNavigate();

  const [company, setCompany] = useSessionStorage("company", {
    selected: {},
    value: -1,
  });

  const [senderAddress, setSenderAddress] = useSessionStorage("SAddress", {});

  useEffect(() => {
    if (hasVipAccess === false) {
      Swal.fire({
        icon: "error",
        title: "به این سرویس دسترسی ندارید",
        text: "برای دریافت اطلاعات بیشتر با پشتیبانی تماس حاصل فرمایید",
        confirmButtonText: "متوجه شدم",
        confirmButtonColor: "gray",
      }).then(() => {
        navigate("/");
      });
    }
  }, [hasVipAccess]);

  if (loading === true) {
    return <Loading />;
  }

  if (!hasVipAccess) {
    return <Fragment></Fragment>;
  }

  return (
    <Fragment>
      <Menu />
      <main className="flex-grow-1 rtl-all content-box py-3">
        <HeaderSection />
        <SenderAddress state={{ senderAddress, setSenderAddress }} />
        <CompanySection state={{ company, setCompany }} type={3} />
        <ShipmentSectionVip
          company={company}
          senderAddress={senderAddress}
          hasFinancialOrder={hasFinancialOrder}
        />
      </main>
      <FooterPostup />
    </Fragment>
  );
};

export default Vip;
